"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApplianceFurnishings = ApplianceFurnishings;
exports.HoaFees = HoaFees;
exports.HomeownersInsurance = HomeownersInsurance;
exports.MortgageRent = MortgageRent;
exports.OtherExpenses = OtherExpenses;
exports.RealEstateTaxes = RealEstateTaxes;
exports.UtilitiesLawnMaintenance = UtilitiesLawnMaintenance;
var _react = _interopRequireDefault(require("react"));
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _RetirementIncomeGapWizardCalc = require("./RetirementIncomeGapWizardCalc.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function MortgageRent(_ref) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref;
  var fieldName = 'housing_mortgageRentCost';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Mortgage and/or Rent',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function HoaFees(_ref2) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref2;
  var fieldName = 'housing_hoaFees';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Homeowner Association (HOA) Fees',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function RealEstateTaxes(_ref3) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref3;
  var fieldName = 'housing_realEstateTaxes';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Real Estate Taxes',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function UtilitiesLawnMaintenance(_ref4) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref4;
  var fieldName = 'housing_utilitiesLawnMaintenance';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Utilities & Lawn Maintenance',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function ApplianceFurnishings(_ref5) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref5;
  var fieldName = 'housing_applianceFurnishings';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Appliance & Furnishings',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function HomeownersInsurance(_ref6) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref6;
  var fieldName = 'housing_homeownersInsurance';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Homeowners/Renters Insurance',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function OtherExpenses(_ref7) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref7;
  var fieldName = 'housing_otherExpenses';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Other',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}